/** @jsx isolateComponent */

import React from 'react';
import { isolateComponent } from '@zapier/common-utils';
import { UniversalNav, UniversalNavPageLayout } from '@zapier/universal-nav';
import { UniversalFooter } from '@zapier/universal-footer';

type Props = {
  /**
   * Content to render within the page.
   */
  children: React.ReactNode;
  /**
   * Content to render within the header area of the page.
   */
  renderHeader: () => React.ReactNode;
  /**
   * Content to render within the footer area of the page.
   */
  renderFooter: () => React.ReactNode;
};

const GlobalLayout = (props: Props) => {
  return (
    <React.Fragment>
      {props.renderHeader()}
      <UniversalNavPageLayout>
        {props.children}
        {props.renderFooter()}
      </UniversalNavPageLayout>
    </React.Fragment>
  );
};

GlobalLayout.defaultProps = {
  renderHeader: () => <UniversalNav />,
  renderFooter: () => <UniversalFooter />,
};

export default GlobalLayout;
